export enum EPrivacy {
    ONLY_ME = 'ONLY_ME',
    EVERY_ONE = 'EVERY_ONE',
  }

  export enum EBoolean {
    NO = 'NO',
    YES = 'YES',
  }